// extracted by mini-css-extract-plugin
export var growableInput = "_9i-0";
export var tagContainer = "_9i-2";
export var textInput = "_9i-1";